import {RxAxios} from '../shared';
import {getHost, getUrlApi} from '../shared/helpers/getApiFromLocation';

const api = new RxAxios({
  baseURL: getUrlApi(),
});

api.setXSession(getHost());
api.setToken(localStorage.getItem('SEI_POCKET_TOKEN_JWT'));

export {api};



// WEBPACK FOOTER //
// ./src/services/api.ts